
namespace TabAurous.Reports {

    @Serenity.Decorators.registerClass()
    export class PurchaseMonthlyGrid extends Serenity.EntityGrid<TabAurous.Purchase.PurchaseItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseMonthlyReport'; }
        protected getDialogType() { return TabAurous.Purchase.PurchaseItemsDialog; }
        protected getIdProperty() { return TabAurous.Purchase.PurchaseItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Purchase.PurchaseItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Purchase.PurchaseItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.Purchase.MonthlyReportService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: LineChartPanel;
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();
            filters.push({
                type: Serenity.ServiceLookupEditor,
                options: {
                    service : 'Purchase/PurchaseItems/PartyList',
                    idField: "LedgerName",
                    textField: "LedgerName",
                    multiple: true
                },
                field: 'PartyId',
                title: 'Vendor',
                handler: w => {
                    var temp = [];
                    if (w.value != null && w.value.length > 0) {
                        var values = w.value;
                        for (var i = 0; i < values.length; i++) {
                            temp.push((values[i]));
                        } if (temp.length != 0) {
                            (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                        }
                    } else
                        (this.view.params as ReportFiltersRequest).LedgerNames = temp;
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,

                options: {
                    lookupKey: 'Karats',   
                },
                field: 'KaratId',
                title: 'Karat',
                handler: w => {
                    var temp = [];
                    if (w.value != null ) 
                            (this.view.params as ReportFiltersRequest).KaratId = w.value;
                        
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },

                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            return filters;
        }



        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({
                title: 'Export',
                cssClass: 'send-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    } 
                    Q.postToService({
                        service: Purchase.MonthlyReportService.baseUrl + '/ExportExcel',
                        request: {
                            PurchaseItems: items,
                        },

                        target: '_blank'
                    });
                }
            });
            return buttons;
        }
    }
}